import React, { useEffect, useState } from 'react';
import BarcodeScanner from '../BarcodeScanner';
import InputNumber from '../InputNumber';
import { useDocument } from '../../utils/DocumentContext';
import { getPackages } from '../../utils/api';

export default function WindowScanner({ onClose }) {
    const [scanResults, setScanResults] = useState([]);
    const [isScanning, setIsScanning] = useState(false);
    const [showQuantityModal, setShowQuantityModal] = useState(false);
    const [pendingScan, setPendingScan] = useState(null);

    // Стани для редагування кількості в картці
    const [showEditQuantityModal, setShowEditQuantityModal] = useState(false);
    const [editingResult, setEditingResult] = useState(null);

    // Состояние для данных склада
    const [warehouseData, setWarehouseData] = useState([]);    // Получаем данные о выбранном документе
    const {
        selectedDocument,
        documentPositions,
        hasSelectedDocument,
        getPositionByBarcode,
        updatePosition,
        updateDocumentPositions
    } = useDocument();    // Загружаем данные склада при открытии сканера
    useEffect(() => {
        loadWarehouseData();
        loadDocumentPositions();
    }, []);

    // Перезагружаем позиции при изменении документа
    useEffect(() => {
        loadDocumentPositions();
    }, [hasSelectedDocument, documentPositions]);

    // Загружаем позиции из активного документа при открытии
    const loadDocumentPositions = () => {
        if (hasSelectedDocument && documentPositions && documentPositions.length > 0) {
            console.log('📋 Завантажуємо позиції з активного документа:', documentPositions.length, 'позицій');
            
            const documentResults = documentPositions.map((position, index) => ({
                id: `doc-${position.id || position.article || index}`,
                barcode: position.barcode || position.article || position.id,
                format: 'DOCUMENT',
                quantity: position.fact || 0,
                timestamp: new Date().toLocaleString(),
                position: position,
                isFound: true,
                addedToDocument: false, // Это уже существующие позиции документа
                fromDocument: true // Флаг что позиция из документа
            }));

            setScanResults(documentResults);
            console.log('📋 Завантажено', documentResults.length, 'позицій з документа');
        }
    };

    const loadWarehouseData = async () => {
        try {
            const response = await getPackages();
            if (Array.isArray(response.packages) && response.packages.length > 0) {
                // Фильтруем пакеты с операцией "PosBal" для получения данных склада
                const posBalPackages = response.packages.filter(pkg => 
                    pkg.ВидОперації === 'PosBal' && pkg.Документы && pkg.Документы.length > 0
                );
                
                if (posBalPackages.length > 0) {
                    // Берем самый новый пакет PosBal
                    const latest = posBalPackages[0];
                    const warehousePositions = [];
                    
                    // Извлекаем все позиции из документов склада
                    latest.Документы.forEach(document => {
                        if (Array.isArray(document.Позиции)) {
                            document.Позиции.forEach(position => {
                                warehousePositions.push({
                                    Код: position.Код,
                                    Наименование: position.Наименование,
                                    Штрихкод: position.Штрихкод || position.Код,
                                    Категория: position.Категория || '',
                                    Подкатегория: position.Подкатегория || '',
                                    ТорговаяМарка: position.ТорговаяМарка || '',
                                    Склад: position.Склад || '',
                                    КоличествоПлан: position.КоличествоПлан || 0,
                                    КоличествоФакт: position.КоличествоФакт || 0,
                                    КоличествоРезерв: position.КоличествоРезерв || 0
                                });
                            });
                        }
                    });
                    
                    setWarehouseData(warehousePositions);
                    console.log('📦 Завантажено дані складу:', warehousePositions.length, 'позицій');
                }
            }        } catch (error) {
            console.error('Помилка завантаження даних складу:', error);
        }
    };    // Функция поиска позиции по штрихкоду в документе
    const findPositionByBarcode = (barcode) => {
        if (!documentPositions || documentPositions.length === 0) {
            return null;
        }

        return documentPositions.find(pos =>
            pos.barcode === barcode ||
            pos.article === barcode ||
            pos.id === barcode
        );
    };

    // Функция поиска позиции в данных склада
    const findWarehousePositionByBarcode = (barcode) => {
        if (!warehouseData || warehouseData.length === 0) {
            return null;
        }

        return warehouseData.find(pos =>
            pos.Штрихкод === barcode ||
            pos.Код === barcode
        );
    };    // Функция создания новой позиции (НЕ добавляем в документ сразу)
    const createNewPositionFromWarehouse = (warehousePosition, scannedQuantity) => {
        const newPosition = {
            id: warehousePosition.Код,
            article: warehousePosition.Код,
            name: warehousePosition.Наименование,
            barcode: warehousePosition.Штрихкод || warehousePosition.Код,
            plan: 0, // План = 0 для новых позиций
            fact: scannedQuantity, // Факт = количество отсканированного
            reserve: 0,
            status: '',
            category: warehousePosition.Категория || '',
            subcategory: warehousePosition.Подкатегория || '',
            brand: warehousePosition.ТорговаяМарка || '',
            warehouse: warehousePosition.Склад || '',
            addedAt: new Date().toISOString() // Отмечаем, что позиция добавлена
        };
        
        console.log('📦 Створено нову позицію з даних складу:', newPosition);
        return newPosition;
    };

    // Нормализуем результат: поддержка строкового и об��ектного формата
    const handleScanResult = (res) => {
        setPendingScan(res);
        setShowQuantityModal(true);
    };    const handleQuantityConfirm = (quantity) => {
        const now = new Date().toLocaleString();
        const asObj =
            typeof pendingScan === 'string'
                ? { text: pendingScan, format: 'UNKNOWN' }
                : { text: pendingScan?.text ?? String(pendingScan ?? ''), format: pendingScan?.format ?? 'UNKNOWN' };

        const barcode = asObj.text;

        // Ищем позицию в документе
        let foundPosition = findPositionByBarcode(barcode);
        let positionAddedToDocument = false;        // Если позиция не найдена в документе, ищем в данных склада
        if (!foundPosition) {
            const warehousePosition = findWarehousePositionByBarcode(barcode);
            if (warehousePosition) {
                // Создаем новую позицию из складских данных
                foundPosition = createNewPositionFromWarehouse(warehousePosition, quantity);
                positionAddedToDocument = true;
                console.log('📦➕ Позицію знайдено в даних складу і буде додано при фіксації');
            } else {
                // Если не найдена даже в складских данных, создаем минимальную позицию
                foundPosition = {
                    id: barcode,
                    article: barcode,
                    name: '',
                    barcode: barcode,
                    plan: 0,
                    fact: quantity,
                    reserve: 0,
                    status: '',
                    category: '',
                    subcategory: '',
                    brand: '',
                    warehouse: '',
                    addedAt: new Date().toISOString()
                };
                positionAddedToDocument = true;
                console.log('❓➕ Створено мінімальну позицію для невідомого штрихкода:', barcode);
            }
        }        // Проверяем, есть ли уже результат сканирования с таким штрихкодом
        const existingResultIndex = scanResults.findIndex(result => result.barcode === barcode);

        if (existingResultIndex !== -1) {
            // Если результат уже существует
            const existingResult = scanResults[existingResultIndex];
            let newQuantity;
            
            if (existingResult.fromDocument) {
                // Для позиций из документа - заменяем количество, а не увеличиваем
                newQuantity = existingResult.quantity + quantity;
                console.log(`📋 Оновлено кількість для позиції документа ${barcode}: +${quantity} (було ${existingResult.quantity}, стало ${newQuantity})`);
            } else {
                // Для обычных отсканированных позиций - увеличиваем количество
                newQuantity = existingResult.quantity + quantity;
                console.log(`📊 Збільшено кількість для ${barcode}: +${quantity} (було ${existingResult.quantity}, стало ${newQuantity})`);
            }

            setScanResults((prev) =>
                prev.map((result, index) =>
                    index === existingResultIndex
                        ? {
                            ...result,
                            quantity: newQuantity,
                            timestamp: now, // Обновляем время последнего сканирования
                            position: foundPosition || result.position, // Обновляем позицию если она была найдена
                            isFound: !!foundPosition || result.isFound,
                            addedToDocument: positionAddedToDocument || result.addedToDocument
                          }
                        : result
                )
            );
        } else {
            // Если результата еще нет, создаем новый
            const scanResult = {
                id: Date.now(),
                barcode: barcode,
                format: asObj.format,
                quantity: quantity,
                timestamp: now,
                position: foundPosition,
                isFound: !!foundPosition,
                addedToDocument: positionAddedToDocument // Отмечаем, была ли позиция добавлена в документ
            };

            setScanResults((prev) => [scanResult, ...prev]);            // НЕ обновляем позицию в документе автоматически - только при фиксации результатов

            console.log(`Створено новий результат сканування для ${barcode}: кількість ${quantity}`);
        }

        setShowQuantityModal(false);
        setPendingScan(null);
    };

    const handleEditQuantityConfirm = (quantity) => {
        if (!editingResult) return;

        const updatedResult = {
            ...editingResult,
            quantity: quantity,
            timestamp: new Date().toLocaleString()
        };

        setScanResults((prev) =>
            prev.map((result) => (result.id === updatedResult.id ? updatedResult : result))
        );
        setShowEditQuantityModal(false);
        setEditingResult(null);
    };    const clearResults = () => {
        // Оставляем только позиции из документа, удаляем отсканированные
        const documentResults = scanResults.filter(result => result.fromDocument);
        setScanResults(documentResults);
    };
    const startScanning = () => setIsScanning(true);
    const captureFrame = () => console.log('Захват кадра');    // Функция фиксации результатов сканирования
    const commitScanResults = () => {
        if (scanResults.length === 0) return;

        console.log('🎯 Починаємо фіксацію результатів сканування...');

        // Начинаем с копии существующих позиций документа
        const updatedPositions = [...documentPositions];
        
        // Обрабатываем только результаты, которые НЕ являются изначальными позициями документа
        // или были изменены после сканирования
        const actualScannedResults = scanResults.filter(result => 
            !result.fromDocument || result.quantity !== (result.position?.fact || 0)
        );

        console.log(`📊 Обробляємо ${actualScannedResults.length} з ${scanResults.length} результатів сканування`);

        actualScannedResults.forEach(result => {
            if (result.isFound && !result.addedToDocument) {
                // Обновляем существующие позиции в документе
                const positionIndex = updatedPositions.findIndex(pos =>
                    pos.barcode === result.barcode ||
                    pos.article === result.barcode ||
                    pos.id === result.barcode
                );

                if (positionIndex !== -1) {
                    updatedPositions[positionIndex] = {
                        ...updatedPositions[positionIndex],
                        fact: result.quantity // Устанавливаем факт = отсканированному количеству
                    };
                    console.log(`✅ Оновлено факт для ${result.barcode}: ${result.quantity}`);
                }
            } else if (result.addedToDocument && result.position) {
                // Добавляем новые позиции в документ (из склада или неизвестные)
                const newPosition = {
                    ...result.position,
                    fact: result.quantity // Устанавливаем факт = отсканированному количеству
                };
                updatedPositions.push(newPosition);
                console.log(`➕ Додано нову позицію в документ: ${result.barcode}`, result.position.name ? '(з даних складу)' : '(невідомий товар)');
            }
        });

        // Обновляем документ с новыми данными
        updateDocumentPositions(updatedPositions);        console.log('🎯 Фіксацію завершено!');
        alert(`Зафіксовано ${actualScannedResults.length} змін у документі`);
        
        // Очищаем результаты после фиксации
        setScanResults([]);
        
        // Закрываем окно после фиксации
        onClose();
    };

    // Обработчик клавиши Escape для закрытия окна
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                if (showQuantityModal) {
                    // Если открыто модальное окно количества, закрываем его
                    setShowQuantityModal(false);
                    setPendingScan(null);
                } else if (showEditQuantityModal) {
                    // Если открыто модальное окно редактирования, закрываем его
                    setShowEditQuantityModal(false);
                    setEditingResult(null);
                } else {
                    // Иначе закрываем все окно сканера
                    onClose();
                }
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [onClose, showQuantityModal, showEditQuantityModal]);

    return (
        <div
            style={{
                position: 'fixed',
                top: 8,
                left: 8,
                right: 8,
                bottom: 8,
                backgroundColor: 'white',
                display: 'flex',
                flexDirection: 'column',
                zIndex: 1000,
                border: '1px solid #ccc',
                borderRadius: 12,
            }}
        >
            {/* Шапка */}
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '8px 12px',
                    backgroundColor: '#1976d2',
                    color: 'white',
                    borderBottom: '1px solid #e0e0e0',
                    borderRadius: '12px 12px 0 0',
                }}
            >
                <h2 style={{ margin: 0, fontSize: 16, fontWeight: '600' }}>Сканер штрих-кодів</h2>
                <button
                    onClick={onClose}
                    style={{
                        background: 'none',
                        border: 'none',
                        fontSize: 20,
                        cursor: 'pointer',
                        color: 'white',
                        padding: 8,
                        borderRadius: 6,
                        minHeight: '40px',
                        minWidth: '40px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                    title="Закрити"
                >
                    ✕
                </button>
            </div>

            {/* Рабочая область */}
            <div
                style={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    padding: 12,
                    gap: 8,
                    overflow: 'hidden',
                    minHeight: 0,
                }}
            >
                {/* ВЕРХ: окно сканера — МИНИМАЛЬНОЕ, с отступами 5 мм сверху и снизу */}
                <div
                    style={{
                        border: '2px solid #e0e0e0',
                        borderRadius: 12,
                        overflow: 'hidden',
                        backgroundColor: '#f8f9fa',
                        marginTop: '5mm',
                        marginBottom: '5mm',
                        flex: '0 0 auto', // не растягиваем по высоте
                        alignSelf: 'stretch', // на всю ширину
                    }}
                >
                    {/* Никаких фиксированных высот — размер «по содержимому» (камера внутри) */}
                    <div style={{ width: '100%' }}>
                        <BarcodeScanner onScanResult={handleScanResult} />
                    </div>
                </div>

                {/* Модальное окно для ввода количества */}
                {showQuantityModal && (
                    <div
                        className="modal-overlay"
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: 'rgba(0,0,0,0.5)',
                            zIndex: 2000,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '16px',
                        }}
                    >
                        <div
                            className="modal"
                            style={{
                                background: '#fff',
                                borderRadius: 12,
                                padding: 24,
                                boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
                                maxWidth: '90vw',
                                maxHeight: '90vh',
                                position: 'relative',
                            }}
                        >
                            <button
                                onClick={() => setShowQuantityModal(false)}
                                className="close-button"
                                style={{
                                    position: 'absolute',
                                    top: 12,
                                    right: 18,
                                    fontSize: 24,
                                    background: 'none',
                                    border: 'none',
                                    cursor: 'pointer',
                                    padding: '4px',
                                    borderRadius: '4px',
                                    minHeight: '32px',
                                    minWidth: '32px',
                                }}
                            >
                                &times;
                            </button>                            <h3 style={{ marginBottom: '16px', fontSize: '18px' }}>
                                Кількість для: {pendingScan?.text || pendingScan}
                            </h3>
                            <InputNumber initialValue={1} onConfirm={handleQuantityConfirm} />
                        </div>
                    </div>
                )}

                {/* Модальное окно для редактирования количества в карточке */}
                {showEditQuantityModal && editingResult && (
                    <div
                        className="modal-overlay"
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: 'rgba(0,0,0,0.5)',
                            zIndex: 2000,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '16px',
                        }}
                    >
                        <div
                            className="modal"
                            style={{
                                background: '#fff',
                                borderRadius: 12,
                                padding: 24,
                                boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
                                maxWidth: '90vw',
                                maxHeight: '90vh',
                                position: 'relative',
                            }}
                        >
                            <button
                                onClick={() => setShowEditQuantityModal(false)}
                                className="close-button"
                                style={{
                                    position: 'absolute',
                                    top: 12,
                                    right: 18,
                                    fontSize: 24,
                                    background: 'none',
                                    border: 'none',
                                    cursor: 'pointer',
                                    padding: '4px',
                                    borderRadius: '4px',
                                    minHeight: '32px',
                                    minWidth: '32px',
                                }}
                            >
                                &times;
                            </button>                            <h3 style={{ marginBottom: '16px', fontSize: '18px' }}>
                                Редагувати кількість для: {editingResult.barcode}
                            </h3>
                            <InputNumber initialValue={editingResult.quantity} onConfirm={handleEditQuantityConfirm} />
                        </div>
                    </div>
                )}

                {/* НИЗ: результаты – занимают всё оставшееся пространство */}
                <div
                    style={{
                        border: '2px solid #e0e0e0',
                        borderRadius: 12,
                        backgroundColor: '#f8f9fa',
                        display: 'flex',
                        flexDirection: 'column',
                        flex: '1 1 auto',
                        minHeight: 0,
                    }}
                >
                    {/* Заголовок с информацией о документе */}
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '10px 12px',
                            borderBottom: '1px solid #e9ecef',
                            flexWrap: 'wrap',
                            gap: '8px'
                        }}
                    >
                        <div>                            <h3 style={{ margin: 0, color: '#1976d2', fontSize: 16, fontWeight: '600' }}>
                                Результати сканування
                            </h3>
                            {hasSelectedDocument && selectedDocument && (
                                <div style={{
                                    marginTop: '8px',
                                    marginBottom: '8px',
                                    fontSize: '15px',
                                    color: '#333',
                                    fontWeight: '500'
                                }}>
                                    {selectedDocument.docType && selectedDocument.docNumber && selectedDocument.date ? (
                                        `${selectedDocument.docType} № ${selectedDocument.docNumber} від ${new Date(selectedDocument.date).toLocaleString('uk-UA')}`
                                    ) : null}
                                </div>
                            )}
                            {hasSelectedDocument && selectedDocument && (
                                <div style={{
                                    fontSize: 12,
                                    color: '#666',
                                    marginTop: 2,
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: '12px'
                                }}>                                    <span><strong>Документ:</strong> {selectedDocument.filename}</span>
                                    <span><strong>Дата:</strong> {new Date(selectedDocument.created).toLocaleDateString('uk-UA')}</span>
                                    <span><strong>Позицій:</strong> {documentPositions?.length || 0}</span>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Прокручиваемый список */}
                    <div
                        style={{
                            flex: '1 1 auto',
                            minHeight: 0,
                            overflow: 'auto',
                            padding: 8,
                            backgroundColor: 'white',
                        }}
                    >
                        {!hasSelectedDocument ? (
                            <div
                                style={{
                                    textAlign: 'center',
                                    color: '#dc3545',
                                    fontStyle: 'italic',
                                    height: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '14px',
                                    padding: '20px',
                                    flexDirection: 'column',
                                    gap: '8px'
                                }}
                            >                                <div style={{ fontSize: '48px' }}>📄</div>
                                <div>Документ не обрано</div>
                                <div style={{ fontSize: '12px', color: '#666' }}>
                                    Оберіть документ для роботи зі сканером
                                </div>
                            </div>
                        ) : scanResults.length === 0 ? (
                            <div
                                style={{
                                    textAlign: 'center',
                                    color: '#6c757d',
                                    fontStyle: 'italic',
                                    height: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '14px',
                                    padding: '20px',
                                }}
                            >
                                Результати сканування з'являться тут
                            </div>
                        ) : (                            scanResults.map((result) => {
                                const position = result.position;
                                const isFound = result.isFound;
                                const isMobile = window.innerWidth < 768;                                // Для позиций документа: План, Скан, Отклонение (План - Скан)
                                const planQty = isFound ? (position?.plan || 0) : 0;
                                const scannedQty = result.quantity; // Отсканированное количество
                                const difference = planQty - scannedQty; // Разница: план - скан

                                return (
                                    <div
                                        key={result.id}
                                        style={{
                                            backgroundColor: isFound ? '#f8f9fa' : '#ffe6e6',
                                            border: `2px solid ${isFound ? '#dee2e6' : '#dc3545'}`,
                                            borderRadius: 8,
                                            padding: 12,
                                            marginBottom: 10,
                                            boxShadow: isFound ? 'none' : '0 2px 4px rgba(220, 53, 69, 0.2)',
                                            display: 'flex',
                                            gap: '12px',
                                            alignItems: 'stretch'
                                        }}
                                    >
                                        {/* ЛЕВАЯ ЧАСТЬ: Информация о товаре */}
                                        <div style={{
                                            flex: '1 1 auto',
                                            minWidth: 0
                                        }}>
                                            {/* Артикул и Штрихкод в одной строке */}
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                marginBottom: 8,
                                                flexWrap: 'wrap',
                                                gap: '8px'
                                            }}>
                                                <div style={{
                                                    fontSize: isMobile ? 14 : 16,
                                                    fontWeight: 'bold',
                                                    color: isFound ? '#495057' : '#dc3545'
                                                }}>
                                                    {position?.article || result.barcode}
                                                </div>
                                                <div style={{
                                                    fontSize: isMobile ? 11 : 13,
                                                    fontFamily: 'monospace',
                                                    color: '#666',
                                                    backgroundColor: 'rgba(0,0,0,0.05)',
                                                    padding: '2px 6px',
                                                    borderRadius: 4
                                                }}>
                                                    {result.barcode}
                                                </div>
                                            </div>                                            {/* Наименование */}
                                            <div style={{
                                                fontSize: isMobile ? 12 : 14,
                                                color: isFound ? '#666' : '#dc3545',
                                                lineHeight: '1.3',
                                                wordBreak: 'break-word'
                                            }}>
                                                {position?.name || (isFound ? 'Не вказано' : 'ТОВАР НЕ ЗНАЙДЕНО')}
                                                {result.addedToDocument && (
                                                    <span style={{
                                                        fontSize: isMobile ? 10 : 11,
                                                        color: '#28a745',
                                                        marginLeft: 8,
                                                        fontWeight: 'bold'
                                                    }}>
                                                        {position?.name ? '[ДОДАНО ЗІ СКЛАДУ]' : '[БУДЕ ДОДАНО]'}
                                                    </span>
                                                )}
                                            </div>
                                        </div>

                                        {/* ПРАВАЯ ЧАСТЬ: Количества в боксах */}
                                        <div style={{
                                            display: 'flex',
                                            flexDirection: isMobile ? 'column' : 'row',
                                            gap: isMobile ? '6px' : '8px',
                                            alignItems: 'center',
                                            flexShrink: 0
                                        }}>                                            {/* Количество План - синий бокс */}
                                            <div style={{
                                                backgroundColor: '#007bff',
                                                color: 'white',
                                                padding: isMobile ? '4px 6px' : '6px 8px',
                                                borderRadius: 6,
                                                minWidth: isMobile ? '40px' : '55px',
                                                textAlign: 'center'
                                            }}>
                                                <div style={{
                                                    fontSize: isMobile ? 8 : 9,
                                                    opacity: 0.9,
                                                    marginBottom: 1
                                                }}>
                                                    План
                                                </div>
                                                <div style={{
                                                    fontSize: isMobile ? 12 : 14,
                                                    fontWeight: 'bold'
                                                }}>
                                                    {planQty}
                                                </div>
                                            </div>

                                            {/* Отсканировано - зеленый бокс, кликабельный */}
                                            <div
                                                onClick={() => {
                                                    setEditingResult(result);
                                                    setShowEditQuantityModal(true);
                                                }}
                                                style={{
                                                    backgroundColor: '#28a745',
                                                    color: 'white',
                                                    padding: isMobile ? '4px 6px' : '6px 8px',
                                                    borderRadius: 6,
                                                    minWidth: isMobile ? '40px' : '55px',
                                                    textAlign: 'center',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s ease'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.target.style.backgroundColor = '#218838';
                                                    e.target.style.transform = 'scale(1.02)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.backgroundColor = '#28a745';
                                                    e.target.style.transform = 'scale(1)';
                                                }}
                                                title="Натисніть для редагування кількості"
                                            >
                                                <div style={{
                                                    fontSize: isMobile ? 8 : 9,
                                                    opacity: 0.9,
                                                    marginBottom: 1
                                                }}>
                                                    Скан
                                                </div>
                                                <div style={{
                                                    fontSize: isMobile ? 12 : 14,
                                                    fontWeight: 'bold'
                                                }}>
                                                    {scannedQty}
                                                </div>
                                            </div>

                                            {/* Разница (факт - скан) - красный/серый бокс */}
                                            <div style={{
                                                backgroundColor: difference !== 0 ? '#dc3545' : '#6c757d',
                                                color: 'white',
                                                padding: isMobile ? '4px 6px' : '6px 8px',
                                                borderRadius: 6,
                                                minWidth: isMobile ? '40px' : '55px',
                                                textAlign: 'center'
                                            }}>
                                                <div style={{
                                                    fontSize: isMobile ? 8 : 9,
                                                    opacity: 0.9,
                                                    marginBottom: 1
                                                }}>                                                                    Відхил.
                                                </div>
                                                <div style={{
                                                    fontSize: isMobile ? 12 : 14,
                                                    fontWeight: 'bold'
                                                }}>
                                                    {difference > 0 ? `+${difference}` : difference}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        )}
                    </div>                    <div style={{ display: 'flex', gap: '8px' }}>
                        <button
                            onClick={onClose}
                            style={{
                                background: '#dc3545',
                                color: 'white',
                                border: 'none',
                                padding: '8px 10px',
                                borderRadius: 6,
                                cursor: 'pointer',
                                fontSize: 16,
                                fontWeight: 'bold',
                                minHeight: '36px',
                                minWidth: '36px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                transition: 'all 0.2s ease',
                            }}
                            title="Закрити вікно без фіксації"
                            onMouseEnter={(e) => {
                                e.target.style.background = '#c82333';
                                e.target.style.transform = 'scale(1.05)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.background = '#dc3545';
                                e.target.style.transform = 'scale(1)';
                            }}
                        >
                            ✗
                        </button><button
                            onClick={commitScanResults}
                            disabled={scanResults.length === 0}
                            style={{
                                background: scanResults.length === 0 ? '#6c757d' : '#28a745',
                                color: 'white',
                                border: 'none',
                                padding: '8px 10px',
                                borderRadius: 6,
                                cursor: scanResults.length === 0 ? 'not-allowed' : 'pointer',
                                fontSize: 16,
                                fontWeight: 'bold',
                                minHeight: '36px',
                                minWidth: '36px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                transition: 'all 0.2s ease',
                                opacity: scanResults.length === 0 ? 0.6 : 1
                            }}
                            title="Зафіксувати результати сканування"
                            onMouseEnter={(e) => {
                                if (scanResults.length > 0) {
                                    e.target.style.background = '#218838';
                                    e.target.style.transform = 'scale(1.05)';
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (scanResults.length > 0) {
                                    e.target.style.background = '#28a745';
                                    e.target.style.transform = 'scale(1)';
                                }
                            }}
                        >
                            ✓
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
